// QBase 점검 상태를 화면에서 읽는다 — 배너와 저장 단추가 같은 값을 본다(services/qbaseMaintenance)
import { useEffect, useState } from 'react';
import { getMaintenance, subscribeMaintenance } from '../services/qbaseMaintenance';

export default function useQbaseMaintenance() {
    const [m, setM] = useState(getMaintenance());
    useEffect(() => {
        setM(getMaintenance());
        return subscribeMaintenance(setM);
    }, []);
    return m;
}
